import styled from 'styled-components';
import { BLACK, WHITE, BG_GRAY, BORDER_GRAY } from '../../../../styles/variables.style';
import media from '../../../../styles/media.style';

export const CameraArea = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 48px;
  margin-bottom: 40px;
  color: ${BLACK};
  border: solid 1px ${BORDER_GRAY.COMMON_1};
  box-sizing: border-box;

  ${media.tabletP`
    width: auto;
    min-width: 250px;
    height: 60px;
    margin-bottom: 60px;
  `};
`;
export const CameraIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-left: 0;

  ${media.tabletP`
    padding-left: 20px;
  `};
`;
export const CameraIcon = styled.img`
  width: 25px;
  height: 21px;

  ${media.tabletP`
    width: 40px;
    height: 34px;
  `};
`;
export const CameraText = styled.div`
  padding: 0 0 0 20px;
  font-size: 11px;

  ${media.tabletP`
    padding: 0 20px;
    font-size: 14px;
  `};
`;
export const SectionGroupCameraApp = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 30px;
`;
export const DescriptionText = styled.span`
  font-size: 9px;
  font-weight: 500;
  color: ${BLACK};
  text-align: center;
`;
export const DLButtonWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;
export const DLButton = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 220px;
  height: 50px;
  margin: 20px 0;
  background-color: ${BLACK};
  color: ${WHITE};
  font-size: 7px;
  cursor: pointer;
`;
export const DownloadSvg = styled.img`
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
`;
export const ManualLink = styled.div`
  font-size: 9px;
  font-weight: 500;
  color: ${BLACK};
  text-align: center;
  text-decoration: underline;
  cursor: pointer;
`;
export const MarkdownComponentStyle = styled.div`
  color: ${BLACK};

  p {
    line-height: 15px;
    font-size: 13px;
    margin-bottom: 6px;
    white-space: nowrap;

    ${media.tabletP`
      line-height: 20px;
      font-size: 18px;
      margin-bottom: 15px;
    `};
  }

  p:last-child {
    margin-bottom: 0;
  }
`;
export const Hr = styled.div`
  width: 100%;
  height: 1px;
  background: ${BG_GRAY.COMMON_4};
`;



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SublimicDiagnosisPage/ScalpCameraPage/ScalpCameraPage.style.js